import React from 'react'

class ErrorPage extends React.Component {
    render() {
        return (
            <div className={"row"}>
                <div className={"col-md-12"}>
                    <h1>Your order is not approved!</h1>

                    <p>Error in payment process. Please try again later</p>

                </div>
            </div>
        )
    }
}

export {ErrorPage}